export default __webpack_public_path__ + "static/media/logo_pkk.5e0594a9.png";